module.exports = __webpack_public_path__ + "img/priyanka.4badad97.webp";